export default __webpack_public_path__ + "static/media/pdf.8f4105783a9ff4ac58d6d86d75d24c60.svg";